var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDribbble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24 0H0v24h24zM6 12c0-3.308 2.692-6 6-6s6 2.692 6 6-2.692 6-6 6-6-2.692-6-6m9.263-3.922a5.08 5.08 0 0 0-4.542-1.01 25 25 0 0 1 1.753 2.783 11 11 0 0 0 2.788-1.773m-3.64 2.088a24 24 0 0 0-1.787-2.78 5.09 5.09 0 0 0-2.774 3.357c.342.034.688.057 1.038.057 1.241 0 2.415-.249 3.524-.634m5.475 1.785A5.08 5.08 0 0 0 15.9 8.714a11.9 11.9 0 0 1-3.006 1.927c.204.406.402.813.583 1.231a8.3 8.3 0 0 1 1.597-.172c.698 0 1.375.089 2.023.251m-4.992-.876-.053-.104c-1.24.448-2.56.729-3.953.729-.4 0-.793-.028-1.181-.068l-.003.044c-.008.107-.016.215-.016.324 0 1.296.485 2.473 1.277 3.371a8.36 8.36 0 0 1 4.428-3.265c-.154-.351-.326-.69-.499-1.03m4.916 1.79a7.4 7.4 0 0 0-1.947-.265c-.34 0-.661.06-.983.12q-.133.026-.266.049c.427 1.112.8 2.25 1.067 3.432a5.09 5.09 0 0 0 2.128-3.336m-2.95 3.794c-.27-1.287-.673-2.521-1.144-3.721A7.44 7.44 0 0 0 8.838 16a5.09 5.09 0 0 0 5.234.66",
  clipRule: "evenodd"
}))));
export default SvgDribbble;